import { RootState } from 'reduxStore/types';

export const getSubcontractorNavigation = (state: RootState) =>
  state?.subcontractorModerationRequest.isNavigateDisabled;
